import { FC } from 'react';
import ContentHeaderLoader from './components/ContentHeaderLoader';
import DetailsSectionLoader from './components/DetailsSectionLoader';
import GroupsLoader from './components/GroupsLoader';
import TokensSectionLoader from './components/TokensSectionLoader';
import EmailSectionLoader from './components/EmailSectionLoader';
import { DefaultFooterComponent } from '@silverfort/sf-components';

const UserDrawerContentLoader: FC = () => (
    <div className="w-full h-full flex flex-col justify-between">
        <div className="flex flex-col gap-4 min-w-full overflow-x-hidden overflow-y-auto">
            <ContentHeaderLoader />
            <div className="p-4 flex flex-col gap-6">
                <DetailsSectionLoader />
                <div className="border-b-2 border-sf-gray-100 border-dashed" />
                <GroupsLoader />
                <TokensSectionLoader />
                <EmailSectionLoader />
            </div>
        </div>
        <div className="border-t border-sf-gray-100 min-h-16 px-6 flex items-center">
            <DefaultFooterComponent
                onCancel={() => {}}
                onApprove={() => {}}
                primaryButtonProps={{
                    disabled: true
                }}
            />
        </div>
    </div>
);

export default UserDrawerContentLoader;
